// 选择商品相关接口

import { postBlobFile, get, deleteApi, imagePost, postJson } from "../axios";

// 获取类目树(平台类类目/店铺类目)
export const getCategoryList = (p) => get(`/common/item-cats/tree`, p);

// 查询常用列表
export const getCollectList = (p) => get(`/analysisConfig/tree`, p);

// 获取自定义类目树
export const getCustomCategoryList = (p) => get(`/common/item-custom-cats/tree`, p);
